import { type FC, memo } from 'react';

import { ImageComponent } from '@/components/Image';
import type { TCardMode } from '@/modules/game/types';

import { ScEmptyGameCardContainer } from './styled';

interface IEmptyGameCardProps {
  mode: TCardMode;
  withoutBottom?: boolean;
  isEveryEmpty?: boolean;
}

export const EmptyGameCard: FC<IEmptyGameCardProps> = memo(
  ({ mode, withoutBottom, isEveryEmpty = false }) => (
    <ScEmptyGameCardContainer
      className={mode}
      isEveryEmpty={isEveryEmpty}
      mode={mode}
      withoutBottom={withoutBottom}
    >
      <ImageComponent
        alt="empty game card icon"
        height="32"
        src="/game/empty-card-icon.svg"
        width="42"
      />
    </ScEmptyGameCardContainer>
  )
);
